import { useAuth } from "@/hooks/useAuth";
import { $api } from "@/lib/api";
import { keepPreviousData } from "@tanstack/react-query";

export function useEnrichedMeetings(limit = 100) {
  const { backendToken } = useAuth();
  return $api.useQuery(
    "get",
    "/api/v1/meetings/enriched",
    { params: { query: { limit } } },
    { staleTime: 5 * 60 * 1000, placeholderData: keepPreviousData, enabled: !!backendToken },
  );
}
